import React, { useContext, useEffect, useState } from 'react';
import NavBar from '../../Components/NavBar/NavBar';
import { DatePicker, Form, Input, Select, Skeleton, Switch } from 'antd';
import { Button, Container, Grid, Pagination, Paper, Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import { greenColor, MONTHS, primaryColor, redColor, secondaryColor, whiteColor } from '../../Utils/Constants';
import TypographyCustom from '../../Components/Typography/TypographyCustom';
import TextArea from 'antd/es/input/TextArea';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { createTransactionAdmin, deleteTransaction, getAllTransactionV2, getDescriptionTransaction, getTotalIncomeTransactionPerMonthInYear, getTransactionActive, getTransactionById, sendReceipt, updateDescriptionTransaction } from '../../Components/api/transaction';
import dayjs from 'dayjs';
import { deleteOutcomeTransaction, getAllOutcomeTransaction, getDescriptionOutcomeTransaction, updateDescriptionOutcomeTransaction } from '../../Components/api/outcomeTransaction';
import Swal from 'sweetalert2/dist/sweetalert2.all.js'
import withReactContent from 'sweetalert2-react-content'
import moment from 'moment';
import { loginKtp, validateKtp } from '../../Components/api/ktp';
import { getListVehicle } from '../../Components/api/vehicle';
import LineChartComponent from '../../Components/Chart/LineChart/LineChart';
import ModalDescription from '../../Components/Modal/ModalDescription';
import UploadComponent from '../../Components/Upload/UploadComponent';
import Signature from '../../Components/Signature/Signature';
import { DataContext } from '../../Context/DataContext';
import { useSearchParams } from 'react-router-dom';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: primaryColor,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const exludeVehicle = [
  'Calya-DK 1053 ACE',
  'Brio-DK 1783 ABR',
  'Xpander-DK 1373 ABF',
  'Agya-DK 1766 IV',
  'Agya-DK 1019 AEF',
  'Xpander-DK 1681 ACF',
  'Brio-DK  1731 ACY',
  'Raize-DK 1098 ABR',
  'NMAX-DK 6609 FI',
  'NMAX-DK 6712 ADN',
  'NMAX-DK 3316 ADV',
  'Beat-DK 4872 ADX',
  'Beat-DK 6526 ACR',
  'Scoopy-DK 6034 ACQ',
  'Scoopy-DK 2447 QI'
]

const Transaction = () => {
  const [form] = Form.useForm();
  const [transactions, setTransactions] = useState([]);
  const [transaction, setTransaction] = useState([]);
  const [listVehicle, setListVehicle] = useState([]);
  const [totalIncome, setTotalIncome] = useState([]);
  const [description, setDescription] = useState('');
  const [id, setId] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [showIncome, setShowIncome] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isAllTransaction, setIsAllTransaction] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [files, setFiles] = useState([]);
  const [signature, setSignature] = useState();
  const [readyVehicle, setReadyVehicle] = useState([]);
  const [vehicleTransactions, setVehicleTransactions] = useState([]);
  const [vehicleTransactionsLoading, setVehicleTransactionsLoading] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [vehicleTransactionsPage, setVehicleTransactionsPage] = useState(1);
  const [vehicleTransactionsTotalPage, setVehicleTransactionsTotalPage] = useState(0);
  const [outcomeTransactions, setOutcomeTransactions] = useState([]);
  const [outcomeTransactionsLoading, setOutcomeTransactionsLoading] = useState(false);
  const [outcomeTransactionsPage, setOutcomeTransactionsPage] = useState(1);
  const [outcomeTransactionsTotalPage, setOutcomeTransactionsTotalPage] = useState(0);
  const [outcomeModalOpen, setOutcomeModalOpen] = useState(false);
  const [outcomeDescription, setOutcomeDescription] = useState('');
  const [outcomeId, setOutcomeId] = useState('');
  const PAGE_SIZE = 10;
  const { allState } = useContext(DataContext)
  const { isEmployee } = allState
  const [searchParams, setSearchParams] = useSearchParams();

  const MySwal = withReactContent(Swal);

  useEffect(() => {
    if (isEmployee) {
      return
    }
    getTotalIncomeTransactionPerMonthInYear(moment().format('YYYY'))
      .then((res) => {
        const defaultData = [{
          month: '-',
          totalIncome: 0
        }];
        const defaultData2 = [{
          month: '',
          totalIncome: 0
        }];
        const sortIncome = res.data.data.sort((a, b) => {
          return MONTHS.indexOf(a.month) - MONTHS.indexOf(b.month);
        });
        const data = [...defaultData, ...sortIncome, ...defaultData2];
        setTotalIncome(data);
      })
  }, [])

  useEffect(() => {
    getListVehicle()
      .then((res) => {
        setListVehicle(res.data.data);
      })
  }, [])

  useEffect(() => {
    const data = localStorage.getItem('transaction');
    if (data) {
      const car = JSON.parse(data);
      form.setFieldsValue({
        carName: car.carName,
        name: car.name,
        phoneNumber: car.phoneNumber,
        email: car.email,
        location: car.location,
        typeVehicle: car.typeVehicle,
        price: car.price,
        deliveryFee: car.deliveryFee,
        pickupFee: car.pickupFee,
        rentPurpose: car.rentPurpose,
        emergencyPhoneNumber: car.emergencyPhoneNumber,
        socialMedia: car.socialMedia,
        officeName: car.officeName,
        helm: car.helm,
        seat: car.seat,
        rainCoat: car.rainCoat,
        odometer: car.odometer,
        barPetrol: car.barPetrol,
        description: car.description,
        nik: car.nik,
        paid: car.paid ?? true,
        includePickup: car.includePickup ?? false
      })
      if (car.carName) {
        fetchVehicleTransactions(car.carName, 1);
        fetchOutcomeTransactions(car.carName, 1);
      }
    }
  }, [])

  useEffect(() => {
    if (isEmployee) {
      return
    }
    setLoading(true);
    if (isAllTransaction) {
      getAllTransactionV2(page, PAGE_SIZE)
        .then((res) => {
          setTransactions(res.data.data.data);
          setTotalPage(Math.ceil(res.data.data.totalData / PAGE_SIZE));
          setLoading(false);
        })
    } else {
      getTransactionActive()
        .then((res) => {
          setTransactions(res.data.data);
          setLoading(false);
          if (searchParams.get("id")) {
            handleDetail(searchParams.get("id"))
          }
        })
    }
  }, [isAllTransaction, page])

  useEffect(() => {
    if (isEmployee) {
      return
    }
    if (!isAllTransaction) {
      const listReadyVehicle = listVehicle.filter((vehicle) => {
        if (exludeVehicle.includes(vehicle.value)) {
          return false;
        }
        const [carName, policeNumber] = vehicle.value.split('-');
        return !transactions.some((transaction) => {
          return transaction.carName === carName && transaction.policeNumber === policeNumber;
        });
      });
      setReadyVehicle(listReadyVehicle);
    }
  }, [transactions, listVehicle])


  const handleSubmit = (values) => {
    let notvalid = false;
    if (values.carName === '' || values.pickUpDate === '' || values.returnDate === '' || values.price === ''
      || values.carName === undefined || values.pickUpDate === undefined || values.returnDate === undefined || values.price === undefined) {
      notvalid = true;
    }

    if (notvalid) {
      MySwal.fire({
        title: <strong>Failed Create Transaction</strong>,
        html: <i>Car Name, Police Number, Pick Up Date, Return Date, Signature cannot be empty</i>,
        showConfirmButton: false,
        timer: 1500,
        icon: 'error'
      })
    } else {
      // set modal are you sure
      const splitVehicle = values.carName.split('-');
      values.carName = splitVehicle[0];
      values.policeNumber = splitVehicle[1];
      MySwal.fire({
        title: <strong>Are you sure?</strong>,
        html: <div>
          <i>You want to create this transaction?</i><br />
          <b>Car Name:</b> {values.carName}<br />
          <b>Price:</b> {values.price}<br />
          <b>Name:</b> {values.name}<br />
          <b>Phone Number:</b> {values.phoneNumber}<br />
          <b>Email:</b> {values.email || '-'}<br />
          <b>Location:</b> {values.location || '-'}<br />
          <b>Description:</b> {values.description || '-'}<br />
          <b>Paid:</b> {values.paid ? 'Yes' : 'No'}<br />
          <b>Include Pickup:</b> {values.includePickup ? 'Yes' : 'No'}
        </div>,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: primaryColor,
        cancelButtonColor: redColor,
        confirmButtonText: 'Yes, create it!'
      }).then((result) => {
        MySwal.showLoading();
        if (result.isConfirmed) {
          const formData = new FormData();
          if (files.length > 0) {
            for (let i = 0; i < files.length; i++) {
              formData.append('file', files[i].originFileObj);
            }
          }

          values.name && formData.append('name', values.name);
          values.phoneNumber && formData.append('phoneNumber', values.phoneNumber);
          values.email && formData.append('email', values.email);
          values.location && formData.append('location', values.location);
          values.pickUpDate && formData.append('pickUpDate', values.pickUpDate);
          values.returnDate && formData.append('returnDate', values.returnDate);
          values.carName && formData.append('carName', values.carName);
          values.policeNumber && formData.append('policeNumber', values.policeNumber);
          values.typeVehicle && formData.append('typeVehicle', values.typeVehicle);
          values.price && formData.append('price', values.price);
          values.deliveryFee && formData.append('deliveryFee', values.deliveryFee);
          values.pickupFee && formData.append('pickupFee', values.pickupFee);
          values.socialMedia && formData.append('socialMedia', values.socialMedia);
          formData.append('paid', values.paid ?? true);
          formData.append('includePickup', values.includePickup ?? false);
          signature && formData.append('signature', signature);
          formData.append('description', JSON.stringify({
            rentPurpose: values.rentPurpose || '',
            emergencyPhoneNumber: values.emergencyPhoneNumber || '',
            officeName: values.officeName || '',
            helm: values.helm || 0,
            rainCoat: values.rainCoat || 0,
            odometer: values.odometer || '',
            barPetrol: values.barPetrol || 0,
            notes: values.description || ''
          }));
          createTransactionAdmin(formData)
            .then((res) => {
              MySwal.fire({
                title: <strong>Create Transaction Success</strong>,
                timer: 4000,
                showConfirmButton: false,
                icon: 'success'
              })
            })
            .catch((err) => {
              MySwal.fire({
                title: <strong>Failed Create Transaction</strong>,
                html: <i>{err.response.data.message}</i>,
                showConfirmButton: false,
                timer: 4000,
                icon: 'error'
              })
            })
            .finally(() => {
              window.location.reload();
              localStorage.removeItem('transaction');
              MySwal.close();
            })
        }
      }).catch((err) => {
        MySwal.fire({
          title: <strong>Failed Create Transaction</strong>,
          html: <i>{err.response.data.message}</i>,
          showConfirmButton: false,
          timer: 1500,
          icon: 'error'
        })
      });

    }
  }

  const handleDetail = (id) => {
    MySwal.showLoading()
    getTransactionById(id)
      .then((res) => {
        setTransaction(res.data.data);
        if (typeof res.data.data.description === 'string') {
          setDescription(res.data.data.description);
        } else {
          setDescription(res.data.data.description.notes);
        }
        setId(id);
      })
      .then(() => {
        setModalOpen(true);
      })
      .catch((err) => {
        MySwal.fire({
          title: <strong>Failed Get Description</strong>,
          html: <i>{err.response.data.message}</i>,
          showConfirmButton: false,
          timer: 1500,
          icon: 'error'
        })
      })
      .finally(() => {
        MySwal.close();
      })
  }

  const handleUpdateDescription = () => {
    MySwal.showLoading()
    updateDescriptionTransaction(id, { description: description })
      .then(() => {
        MySwal.fire({
          title: <strong>Update Description Success</strong>,
          timer: 1500,
          showConfirmButton: false,
          icon: 'success'
        })
      })
      .then(() => {
        setModalOpen(false);
      })
      .catch((err) => {
        MySwal.fire({
          title: <strong>Failed Update Description</strong>,
          html: <i>{err.response.data.message}</i>,
          showConfirmButton: false,
          timer: 1500,
          icon: 'error'
        })
      })
      .finally(() => {
        MySwal.close();
      })
  }

  const handleDelete = (event, id) => {
    event.stopPropagation();
    MySwal.fire({
      title: <strong>Are you sure?</strong>,
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: redColor,
      cancelButtonColor: primaryColor,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.showLoading()
        deleteTransaction(id)
          .then(() => {
            MySwal.fire({
              title: <strong>Delete Transaction Success</strong>,
              timer: 1500,
              showConfirmButton: false,
              icon: 'success'
            })
          })
          .finally(() => {
            window.location.reload();
          });
      }
    })
      .catch((err) => {
        MySwal.fire({
          title: <strong>Failed Delete Transaction</strong>,
          html: <i>{err.response.data.message}</i>,
          showConfirmButton: false,
          timer: 1500,
          icon: 'error'
        })
      })
  }

  const fetchOutcomeTransactions = (vehicleValue, page = 1) => {
    if (!vehicleValue) {
      setOutcomeTransactions([]);
      setOutcomeTransactionsTotalPage(0);
      return;
    }
    const [carName, ...policeNumberParts] = vehicleValue.split('-');
    const policeNumber = policeNumberParts.join('-').trim();
    setOutcomeTransactionsLoading(true);
    getAllOutcomeTransaction(page, PAGE_SIZE, carName, policeNumber)
      .then((res) => {
        setOutcomeTransactions(res.data.data.data);
        setOutcomeTransactionsTotalPage(Math.ceil(res.data.data.totalData / PAGE_SIZE));
      })
      .finally(() => {
        setOutcomeTransactionsLoading(false);
      });
  };

  const fetchVehicleTransactions = (vehicleValue, page = 1) => {
    if (!vehicleValue) {
      setVehicleTransactions([]);
      setOutcomeTransactions([]);
      setSelectedVehicle(null);
      setVehicleTransactionsTotalPage(0);
      setOutcomeTransactionsTotalPage(0);
      return;
    }
    const [carName, ...policeNumberParts] = vehicleValue.split('-');
    const policeNumber = policeNumberParts.join('-').trim();
    setSelectedVehicle(vehicleValue);
    setVehicleTransactionsLoading(true);
    getAllTransactionV2(page, PAGE_SIZE, carName, policeNumber)
      .then((res) => {
        setVehicleTransactions(res.data.data.data);
        setVehicleTransactionsTotalPage(Math.ceil(res.data.data.totalData / PAGE_SIZE));
      })
      .finally(() => {
        setVehicleTransactionsLoading(false);
      });
  };

  const handleVehicleChange = (value) => {
    setVehicleTransactionsPage(1);
    setOutcomeTransactionsPage(1);
    fetchVehicleTransactions(value, 1);
    fetchOutcomeTransactions(value, 1);
  };

  const handleVehicleTransactionsPagination = (event, value) => {
    setVehicleTransactionsPage(value);
    fetchVehicleTransactions(selectedVehicle, value);
  };

  const handleOutcomeTransactionsPagination = (event, value) => {
    setOutcomeTransactionsPage(value);
    fetchOutcomeTransactions(selectedVehicle, value);
  };

  const handleOutcomeDetail = (id) => {
    MySwal.showLoading()
    getDescriptionOutcomeTransaction(id)
      .then((res) => {
        setOutcomeDescription(res.data.data.description);
        setOutcomeId(id);
      })
      .then(() => {
        setOutcomeModalOpen(true);
      })
      .catch((err) => {
        MySwal.fire({
          title: <strong>Failed Get Description</strong>,
          html: <i>{err.response.data.message}</i>,
          showConfirmButton: false,
          timer: 1500,
          icon: 'error'
        })
      })
      .finally(() => {
        MySwal.close();
      })
  }

  const handleOutcomeUpdateDescription = () => {
    MySwal.showLoading()
    updateDescriptionOutcomeTransaction(outcomeId, { description: outcomeDescription })
      .then(() => {
        MySwal.fire({
          title: <strong>Update Description Success</strong>,
          timer: 1500,
          showConfirmButton: false,
          icon: 'success'
        })
      })
      .then(() => {
        setOutcomeModalOpen(false);
      })
      .catch((err) => {
        MySwal.fire({
          title: <strong>Failed Update Description</strong>,
          html: <i>{err.response.data.message}</i>,
          showConfirmButton: false,
          timer: 1500,
          icon: 'error'
        })
      })
      .finally(() => {
        MySwal.close();
      })
  }

  const handleOutcomeDelete = (event, outcomeTransactionId) => {
    event.stopPropagation();
    MySwal.fire({
      title: <strong>Are you sure?</strong>,
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: redColor,
      cancelButtonColor: primaryColor,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.showLoading()
        deleteOutcomeTransaction(outcomeTransactionId)
          .then(() => {
            MySwal.fire({
              title: <strong>Delete Outcome Transaction Success</strong>,
              timer: 1500,
              showConfirmButton: false,
              icon: 'success'
            })
            fetchOutcomeTransactions(selectedVehicle, outcomeTransactionsPage);
          })
      }
    })
      .catch((err) => {
        MySwal.fire({
          title: <strong>Failed Delete Outcome Transaction</strong>,
          html: <i>{err.response.data.message}</i>,
          showConfirmButton: false,
          timer: 1500,
          icon: 'error'
        })
      })
      .finally(() => {
        MySwal.close();
      })
  }

  const handleBlur = () => {
    // save te local storage
    const data = {
      carName: form.getFieldValue('carName'),
      name: form.getFieldValue('name'),
      phoneNumber: form.getFieldValue('phoneNumber'),
      email: form.getFieldValue('email'),
      location: form.getFieldValue('location'),
      typeVehicle: form.getFieldValue('typeVehicle'),
      price: form.getFieldValue('price'),
      deliveryFee: form.getFieldValue('deliveryFee'),
      pickupFee: form.getFieldValue('pickupFee'),
      rentPurpose: form.getFieldValue('rentPurpose'),
      emergencyPhoneNumber: form.getFieldValue('emergencyPhoneNumber'),
      socialMedia: form.getFieldValue('socialMedia'),
      officeName: form.getFieldValue('officeName'),
      helm: form.getFieldValue('helm'),
      seat: form.getFieldValue('seat'),
      rainCoat: form.getFieldValue('rainCoat'),
      odometer: form.getFieldValue('odometer'),
      barPetrol: form.getFieldValue('barPetrol'),
      description: form.getFieldValue('description'),
      nik: form.getFieldValue('nik'),
      paid: form.getFieldValue('paid'),
      includePickup: form.getFieldValue('includePickup')
    }
    localStorage.setItem('transaction', JSON.stringify(data));
  }


  const generateEachSkeleton = (id) => {
    return (
      <StyledTableRow
        key={id}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        <StyledTableCell component="th" scope="row">
          <Skeleton loading={transactions.length === 0} active paragraph={0} />
        </StyledTableCell>
        <StyledTableCell><Skeleton loading={transactions.length === 0} active paragraph={0} /></StyledTableCell>
        <StyledTableCell><Skeleton loading={transactions.length === 0} active paragraph={0} /></StyledTableCell>
        <StyledTableCell><Skeleton loading={transactions.length === 0} active paragraph={0} /></StyledTableCell>
        <StyledTableCell><Skeleton loading={transactions.length === 0} active paragraph={0} /></StyledTableCell>
        <StyledTableCell><Skeleton loading={transactions.length === 0} active paragraph={0} /></StyledTableCell>
      </StyledTableRow>
    )
  }

  const generateSkeleton = () => {
    return (
      <>
        {generateEachSkeleton(1)}
        {generateEachSkeleton(2)}
        {generateEachSkeleton(3)}
        {generateEachSkeleton(4)}
        {generateEachSkeleton(5)}
      </>
    );
  }

  const handleSendReceipt = (event, id) => {
    event.stopPropagation();
    MySwal.showLoading()
    sendReceipt(id)
      .then(() => {
        MySwal.fire({
          title: <strong>Send Receipt Success</strong>,
          timer: 1500,
          showConfirmButton: false,
          icon: 'success'
        })
      })
      .catch((err) => {
        MySwal.fire({
          title: <strong>Failed Send Receipt</strong>,
          html: <i>{err.response?.data?.message}</i>,
          showConfirmButton: false,
          timer: 1500,
          icon: 'error'
        })
      })
  }

  const handleExtend = (event, car) => {
    event.stopPropagation();
    const pickUpDate = car.returnDate ? dayjs(car.returnDate) : dayjs();
    form.setFieldsValue({
      carName: `${car.carName}-${car.policeNumber}`,
      name: car.name,
      phoneNumber: car.phoneNumber,
      email: car.email,
      location: car.location,
      typeVehicle: car.typeVehicle,
      price: car.price,
      deliveryFee: car.deliveryFee,
      pickupFee: car.pickupFee,
      rentPurpose: car.description ? car.description.rentPurpose : '',
      emergencyPhoneNumber: car.description ? car.description.emergencyPhoneNumber : '',
      socialMedia: car.socialMedia,
      officeName: car.description ? car.description.officeName : '',
      helm: car.description ? car.description.helm : '',
      seat: car.description ? car.description.seat : '',
      rainCoat: car.description ? car.description.rainCoat : '',
      odometer: car.description ? car.description.odometer : '',
      barPetrol: car.description ? car.description.barPetrol : '',
      description: car.description
        ? typeof car.description === 'string'
          ? car.description
          : car.description.notes
        : '',
      paid: car.paid ?? true,
      includePickup: car.includePickup ?? false,
      pickUpDate: pickUpDate.isValid() ? pickUpDate : dayjs(),
      returnDate: (pickUpDate.isValid() ? pickUpDate : dayjs()).add(1, 'month'),
    })
    setVehicleTransactionsPage(1);
    setOutcomeTransactionsPage(1);
    fetchVehicleTransactions(`${car.carName}-${car.policeNumber}`, 1);
    fetchOutcomeTransactions(`${car.carName}-${car.policeNumber}`, 1);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handlePagination = (event, value) => {
    setPage(value);
  }

  const validateNik = () => {
    MySwal.showLoading()
    // const tokenClient = getClientToken();
    const payloadData = {
      nik: form.getFieldValue('nik'),
      name: form.getFieldValue('name'),
      // tokenClient
    }
    validateKtp(payloadData)
      .then((res) => {
        const isValid = res.data.data.content[0].NAMA_LGKP
          && res.data.data.content[0].NAMA_LGKP === "Sesuai (100)"
        if (isValid) {
          MySwal.fire({
            title: <strong>Validate Success</strong>,
            html: <i>NIK {form.getFieldValue('nik')} is valid</i>,
            timer: 1500,
            showConfirmButton: false,
            icon: 'success'
          })
        } else {
          MySwal.fire({
            title: <strong>Validate Failed</strong>,
            html: <i>NIK {form.getFieldValue('nik')} is not valid</i>,
            showConfirmButton: false,
            timer: 1500,
            icon: 'error'
          })
        }
      })
      .catch((err) => {
        MySwal.fire({
          title: <strong>Error Validation</strong>,
          html: <i>{err.response.data.message}</i>,
          showConfirmButton: false,
          timer: 1500,
          icon: 'error'
        })
      })
  }

  const getClientToken = async () => {
    if (localStorage.getItem('token_client')) {
      return localStorage.getItem('token_client');
    }
    const token = await loginKtp()
      .then((res) => {
        const token = res.data.data.token;
        localStorage.setItem('token_client', res.data.data.token);
        return token;
      })
      .catch((err) => {
        MySwal.fire({
          title: <strong>Failed Get Token</strong>,
          html: <i>{err.response.data.message}</i>,
          showConfirmButton: false,
          timer: 1500,
          icon: 'error'
        })
      });
    return token;
  }

  return (
    <div>
      <NavBar isPageAdmin={true} />
      {
        showIncome && <LineChartComponent dataset={totalIncome} xKey={"month"} yKey={"totalIncome"} />
      }
      <Container style={{ textAlign: 'center', width: "80%", marginTop: "20px" }}>
        <Button onClick={() => setShowIncome(!showIncome)} style={{ backgroundColor: secondaryColor, color: whiteColor, width: "100%" }}>
          {showIncome ? 'Tutup Grafik' : 'Lihat Grafik Pemasukan'}
        </Button>
        <br />
        <br />
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          onBlur={handleBlur}
          initialValues={{
            paid: true,
            includePickup: false
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Form.Item name={'carName'} label={'Vehicle'} required>
                <Select
                  placeholder={'Select Vehicle'}
                  style={{ textAlign: "left" }}
                  showSearch
                  optionFilterProp="children"
                  onChange={handleVehicleChange}
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  options={listVehicle}
                />
              </Form.Item>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Form.Item name={'typeVehicle'} label={'Type'}>
                <Select
                  style={{ textAlign: "left" }}
                  showSearch
                  optionFilterProp="children"
                  // onSearch={onSearch}
                  options={
                    [
                      { label: 'CAR', value: 'CAR' },
                      { label: 'MOTORCYCLE', value: 'MOTORCYCLE' }
                    ]
                  }
                  defaultValue={'MOTORCYCLE'}
                />
              </Form.Item>
            </Grid>
            <Grid item xs={6}>
              <Form.Item name={'price'} label={'Price'} required>
                <Input placeholder={'1000000'} />
              </Form.Item>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Form.Item name={'deliveryFee'} label={'Delivery Fee'}>
                <Input placeholder={'20000'} />
              </Form.Item>
            </Grid>
            <Grid item xs={6}>
              <Form.Item name={'pickupFee'} label={'Pickup Fee'}>
                <Input placeholder={'20000'} />
              </Form.Item>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Form.Item name={'paid'} label={'Paid'} valuePropName="checked">
                <Switch />
              </Form.Item>
            </Grid>
            <Grid item xs={6}>
              <Form.Item name={'includePickup'} label={'Include Pickup'} valuePropName="checked">
                <Switch />
              </Form.Item>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Form.Item name={'name'} label={'Customer Name'} required>
                <Input placeholder={'Customer Name'} />
              </Form.Item>
            </Grid>
            <Grid item xs={6}>
              <Form.Item name={'phoneNumber'} label={'Phone Number'} required>
                <Input placeholder={'Phone Number'} />
              </Form.Item>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Form.Item name={'rentPurpose'} label={'Rent Purpose'}>
                <Input placeholder={'Rent Purpose'} />
              </Form.Item>
            </Grid>
            <Grid item xs={6}>
              <Form.Item name={'emergencyPhoneNumber'} label={'Emergency Phone Number'}>
                <Input placeholder={'Emergency Phone Number'} />
              </Form.Item>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Form.Item name={'email'} label={'Email'} >
                <Input placeholder={'Email'} />
              </Form.Item>
            </Grid>
            <Grid item xs={6}>
              <Form.Item name={'location'} label={'Address'} required>
                <Input placeholder={'Address'} />
              </Form.Item>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Form.Item name='pickUpDate' label={'Pick Up Date'} required>
                <DatePicker
                  placeholder={`${moment().format('YYYY-MM-DD')}`}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Grid>
            <Grid item xs={6}>
              <Form.Item name='returnDate' label={'Return Date'} required>
                <DatePicker
                  placeholder={`${moment().format('YYYY-MM-DD')}`}
                  style={{ width: "100%", marginRight: "3%" }}
                />
              </Form.Item>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Form.Item name={'socialMedia'} label={'Social Media'}>
                <Input placeholder={'Social Media'} />
              </Form.Item>
            </Grid>
            <Grid item xs={6}>
              <Form.Item name={'officeName'} label={'Office Name (For Employee)'}>
                <Input placeholder={'Office Name'} />
              </Form.Item>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Form.Item name={'helm'} label={'Helm'}>
                <Input placeholder={'0'} />
              </Form.Item>
            </Grid>
            <Grid item xs={6}>
              <Form.Item name={'rainCoat'} label={'Rain Coat'}>
                <Input placeholder={'0'} />
              </Form.Item>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Form.Item name={'odometer'} label={'Odometer'}>
                <Input placeholder={'30000'} />
              </Form.Item>
            </Grid>
            <Grid item xs={6}>
              <Form.Item name={'barPetrol'} label={'Bar Petrol'}>
                <Input placeholder={'2'} />
              </Form.Item>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Form.Item name={'nik'} label={'NIK'} required>
                <Input placeholder={'NIK'} />
              </Form.Item>
            </Grid>
            <Grid item xs={6}>
              <Form.Item label={'  '} >
                <Button onClick={validateNik} style={{ backgroundColor: primaryColor, color: whiteColor, width: "100%" }}>
                  <TypographyCustom
                    content="validateNik"
                  />
                </Button>
              </Form.Item>
            </Grid>
          </Grid>
          <Form.Item name={'description'} label={'Notes'} >
            <TextArea rows={3} placeholder={'Notes'} />
          </Form.Item>
          <Grid container spacing={2} style={{ marginBottom: "60px" }}>
            <Grid item xs={6}>
              <UploadComponent setFiles={setFiles} />
            </Grid>
            <Grid item xs={6}>
              <Signature setSignature={setSignature} />
            </Grid>
          </Grid>
          <Button type='submit' style={{ backgroundColor: primaryColor, color: whiteColor, width: "100%" }}>
            <TypographyCustom
              content="submit"
            />
          </Button>
          {
            selectedVehicle && (
              <>
                <br />
                <br />
                <TypographyCustom
                  variant="h5"
                  content="Vehicle Transaction History"
                />
                <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
                  <Table style={{ textAlign: 'center' }}>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Name</StyledTableCell>
                        <StyledTableCell>Phone Number</StyledTableCell>
                        <StyledTableCell>Pick Up Date</StyledTableCell>
                        <StyledTableCell>Return Date</StyledTableCell>
                        <StyledTableCell>Price</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {vehicleTransactionsLoading && generateSkeleton()}
                      {
                        !vehicleTransactionsLoading && vehicleTransactions.map((car) => (
                          <StyledTableRow
                            key={car.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            onClick={() => handleDetail(car.id)}
                          >
                            <StyledTableCell component="th" scope="row">
                              {car.name}
                            </StyledTableCell>
                            <StyledTableCell>{car.phoneNumber}</StyledTableCell>
                            <StyledTableCell>{car.pickUpDate}</StyledTableCell>
                            <StyledTableCell>{car.returnDate}</StyledTableCell>
                            <StyledTableCell>{car.price}</StyledTableCell>
                          </StyledTableRow>
                        ))
                      }
                      {
                        !vehicleTransactionsLoading && vehicleTransactions.length === 0 && (
                          <StyledTableRow>
                            <StyledTableCell colSpan={5} align="center">
                              No transaction history found
                            </StyledTableCell>
                          </StyledTableRow>
                        )
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
                {
                  vehicleTransactionsTotalPage > 1 &&
                  <div style={{ textAlign: 'center', marginTop: "1rem", display: 'flex' }}>
                    <Pagination count={vehicleTransactionsTotalPage} page={vehicleTransactionsPage} onChange={handleVehicleTransactionsPagination} showFirstButton showLastButton />
                  </div>
                }
                <br />
                <br />
                <TypographyCustom
                  variant="h5"
                  content="Outcome Transaction History"
                />
                <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
                  <Table style={{ textAlign: 'center' }}>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Type</StyledTableCell>
                        <StyledTableCell>Price</StyledTableCell>
                        <StyledTableCell>Date</StyledTableCell>
                        <StyledTableCell>Description</StyledTableCell>
                        <StyledTableCell>Action</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {outcomeTransactionsLoading && generateSkeleton()}
                      {
                        !outcomeTransactionsLoading && outcomeTransactions.map((outcome) => (
                          <StyledTableRow
                            key={outcome.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            onClick={() => handleOutcomeDetail(outcome.id)}
                          >
                            <StyledTableCell component="th" scope="row">
                              {outcome.outcomeType}
                            </StyledTableCell>
                            <StyledTableCell>{outcome.price}</StyledTableCell>
                            <StyledTableCell>{moment(outcome.eventDate).format('YYYY-MM-DD')}</StyledTableCell>
                            <StyledTableCell>{outcome.description}</StyledTableCell>
                            <StyledTableCell>
                              <button
                                style={{ color: whiteColor, border: 'none', cursor: 'pointer', backgroundColor: redColor }}
                                onClick={(e) => handleOutcomeDelete(e, outcome.id)}>
                                Delete
                              </button>
                            </StyledTableCell>
                          </StyledTableRow>
                        ))
                      }
                      {
                        !outcomeTransactionsLoading && outcomeTransactions.length === 0 && (
                          <StyledTableRow>
                            <StyledTableCell colSpan={5} align="center">
                              No outcome transaction history found
                            </StyledTableCell>
                          </StyledTableRow>
                        )
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
                {
                  outcomeTransactionsTotalPage > 1 &&
                  <div style={{ textAlign: 'center', marginTop: "1rem", display: 'flex' }}>
                    <Pagination count={outcomeTransactionsTotalPage} page={outcomeTransactionsPage} onChange={handleOutcomeTransactionsPagination} showFirstButton showLastButton />
                  </div>
                }
                {
                  outcomeModalOpen && <ModalDescription
                    modalOpen={outcomeModalOpen}
                    setModalOpen={setOutcomeModalOpen}
                    description={outcomeDescription}
                    setDescription={setOutcomeDescription}
                    setId={setOutcomeId}
                    setSearchParams={() => { }}
                    handleUpdateDescription={handleOutcomeUpdateDescription}
                  />
                }
              </>
            )
          }
        </Form>
      </Container>
      {
        !isEmployee && <Container style={{ marginBlock: "2rem" }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button onClick={() => setIsAllTransaction(!isAllTransaction)} style={{ backgroundColor: greenColor, color: whiteColor, width: "100%", marginBottom: "1rem" }}>
                {isAllTransaction ? 'Lihat Transaksi Berjalan' : 'Lihat Semua Transaksi'}
              </Button>
            </Grid>
          </Grid>
          <TableContainer component={Paper}>
            <Table style={{ textAlign: 'center' }}>
              <TableHead>
                <TableRow>
                  <StyledTableCell>Vehicle</StyledTableCell>
                  <StyledTableCell>Police Number</StyledTableCell>
                  <StyledTableCell>Name</StyledTableCell>
                  <StyledTableCell>Phone Number</StyledTableCell>
                  <StyledTableCell>Pick Up Date</StyledTableCell>
                  <StyledTableCell>Return Date</StyledTableCell>
                  <StyledTableCell>Action</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading && generateSkeleton()}
                {
                  transactions !== null && !loading && transactions.map((car, index) => {
                    return (
                      <StyledTableRow
                        key={car.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        onClick={() => handleDetail(car.id)}
                      >
                        <StyledTableCell component="th" scope="row">
                          {car.carName}
                        </StyledTableCell>
                        <StyledTableCell>{car.policeNumber}</StyledTableCell>
                        <StyledTableCell>{car.name}</StyledTableCell>
                        <StyledTableCell>{car.phoneNumber}</StyledTableCell>
                        <StyledTableCell>{car.pickUpDate}</StyledTableCell>
                        <StyledTableCell>{car.returnDate}</StyledTableCell>
                        <StyledTableCell>
                          <button
                            style={{ color: whiteColor, border: 'none', cursor: 'pointer', backgroundColor: primaryColor }}
                            onClick={(e) => handleExtend(e, car)}>
                            Extend
                          </button>
                          {' '}
                          <button
                            style={{ color: whiteColor, border: 'none', cursor: 'pointer', backgroundColor: greenColor }}
                            onClick={(e) => handleSendReceipt(e, car.id)}>
                            Receipt
                          </button>
                          {' '}
                          <button
                            style={{ color: whiteColor, border: 'none', cursor: 'pointer', backgroundColor: redColor }}
                            onClick={(e) => handleDelete(e, car.id)}>
                            Delete
                          </button>
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })
                }
              </TableBody>
            </Table>
          </TableContainer>
          {
            isAllTransaction &&
            <div style={{ textAlign: 'center', marginTop: "1rem", display: 'flex' }}>
              <Pagination count={totalPage} page={page} onChange={handlePagination} showFirstButton showLastButton />
            </div>
          }
          <br />
          <br />
          <TypographyCustom
            variant="h5"
            content="Unpaid Transaction"
          />
          <TableContainer component={Paper}>
            <Table style={{ textAlign: 'center' }}>
              <TableHead>
                <TableRow>
                  <StyledTableCell>Vehicle</StyledTableCell>
                  <StyledTableCell>Police Number</StyledTableCell>
                  <StyledTableCell>Name</StyledTableCell>
                  <StyledTableCell>Phone Number</StyledTableCell>
                  <StyledTableCell>Pick Up Date</StyledTableCell>
                  <StyledTableCell>Return Date</StyledTableCell>
                  <StyledTableCell>Action</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading && generateSkeleton()}
                {
                  transactions !== null && !loading && transactions.filter((car) => car.paid === false).map((car) => {
                    return (
                      <StyledTableRow
                        key={car.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        onClick={() => handleDetail(car.id)}
                      >
                        <StyledTableCell component="th" scope="row">
                          {car.carName}
                        </StyledTableCell>
                        <StyledTableCell>{car.policeNumber}</StyledTableCell>
                        <StyledTableCell>{car.name}</StyledTableCell>
                        <StyledTableCell>{car.phoneNumber}</StyledTableCell>
                        <StyledTableCell>{car.pickUpDate}</StyledTableCell>
                        <StyledTableCell>{car.returnDate}</StyledTableCell>
                        <StyledTableCell>
                          <button
                            style={{ color: whiteColor, border: 'none', cursor: 'pointer', backgroundColor: primaryColor }}
                            onClick={(e) => handleExtend(e, car)}>
                            Extend
                          </button>
                          {' '}
                          <button
                            style={{ color: whiteColor, border: 'none', cursor: 'pointer', backgroundColor: greenColor }}
                            onClick={(e) => handleSendReceipt(e, car.id)}>
                            Receipt
                          </button>
                          {' '}
                          <button
                            style={{ color: whiteColor, border: 'none', cursor: 'pointer', backgroundColor: redColor }}
                            onClick={(e) => handleDelete(e, car.id)}>
                            Delete
                          </button>
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })
                }
                {
                  !loading && transactions !== null && transactions.filter((car) => car.paid === false).length === 0 && (
                    <StyledTableRow>
                      <StyledTableCell colSpan={7} align="center">
                        No unpaid transaction found
                      </StyledTableCell>
                    </StyledTableRow>
                  )
                }
              </TableBody>
            </Table>
          </TableContainer>
          <br />
          <br />
          <TypographyCustom
            variant="h5"
            content="Available Vehicle"
          />
          <TableContainer component={Paper}>
            <Table style={{ textAlign: 'center' }}>
              <TableHead>
                <TableRow>
                  <StyledTableCell>Vehicle</StyledTableCell>
                  <StyledTableCell>Police Number</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  readyVehicle !== null && !loading && readyVehicle.map((car, index) => {
                    return (
                      <StyledTableRow
                        key={car.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        onClick={() => handleDetail(car.id)}
                      >
                        <StyledTableCell component="th" scope="row">
                          {car.value.split('-')[0]}
                        </StyledTableCell>
                        <StyledTableCell>{car.value.split('-')[1]}</StyledTableCell>
                      </StyledTableRow>
                    );
                  })
                }
              </TableBody>
            </Table>
          </TableContainer>
          <br />
          <br />
          <TypographyCustom
            variant="h5"
            content="Untracked Vehicle"
          />
          <TableContainer component={Paper}>
            <Table style={{ textAlign: 'center' }}>
              <TableHead>
                <TableRow>
                  <StyledTableCell>Vehicle</StyledTableCell>
                  <StyledTableCell>Police Number</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  exludeVehicle.map((car, index) => {
                    return (
                      <StyledTableRow
                        key={car.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        onClick={() => handleDetail(car.id)}
                      >
                        <StyledTableCell component="th" scope="row">
                          {car.split('-')[0]}
                        </StyledTableCell>
                        <StyledTableCell>{car.split('-')[1]}</StyledTableCell>
                      </StyledTableRow>
                    );
                  })
                }
              </TableBody>
            </Table>
          </TableContainer>
          {
            modalOpen && <ModalDescription
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              description={description}
              setDescription={setDescription}
              setId={setId}
              setSearchParams={setSearchParams}
              handleUpdateDescription={handleUpdateDescription}
              data={transaction}
            />
          }
        </Container>
      }
    </div>
  );
};

export default Transaction;